/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Logger, clientUtil } from "@html-core";

export class TrustedTypeUtil {
   private iwaPolicy: Partial<TrustedTypePolicy> | null = null;

   private workerUrls = [
      `./audioworker.${__BUILD_NUMBER__}.js`,
      `./videoworker.${__BUILD_NUMBER__}.js`,
      `./audioWorklet.${__BUILD_NUMBER__}.worker.js`,
      `./worker-for-timeout.${__BUILD_NUMBER__}.js`
   ];

   constructor() {
      if (window.trustedTypes && window.trustedTypes.createPolicy) {
         this.iwaPolicy = window.trustedTypes.createPolicy("iwaPolicy", {
            // set TrustedScriptURL for worker scripts
            createScriptURL: (s, type, sink) => {
               if (this.workerUrls.includes(s)) {
                  return s;
               }
               return "";
            },
            // policy for creating TrustedHTML, Check format of DOM as XML outside the filtering function
            createHTML: (string) => string
         });
      }
      Logger.debug("TrustedTypeUtil initialized");
   }

   public createTrustedHTML(html: string): TrustedHTML | string {
      if (clientUtil.isIwaClient() && this.iwaPolicy) {
         return this.iwaPolicy.createHTML(html);
      }
      return html;
   }

   public createTrustedScriptURL(url: string): TrustedScriptURL | string {
      if (clientUtil.isIwaClient() && this.iwaPolicy) {
         return this.iwaPolicy.createScriptURL(url);
      }
      return url;
   }
}

export const trustedTypeUtil = new TrustedTypeUtil();
